import React, { useEffect, useState, useRef } from 'react';
import { MessageSquare, Plus, Send, ChevronLeft, Info } from 'lucide-react';
import api from '../../api/client';
import { avvisaTicketCambiati } from '../../utils/useTicketDaLeggere';
import { ARGOMENTI_TICKET, EMAIL_DINK } from '../../utils/ticketArgomenti';
import { SceltaAllegati, ElencoAllegati } from '../../components/supporto/AllegatiTicket';

const STATO_COLOR = { APERTO:'#F59E0B', IN_LAVORAZIONE:'#3B82F6', CHIUSO:'#22C55E' };
const STATO_LABEL = { APERTO:'Aperto', IN_LAVORAZIONE:'In lavorazione', CHIUSO:'Chiuso' };

const fmtDate = (d) => new Date(d).toLocaleString('it-IT', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
const etichetta = { fontSize: 'var(--font-size-xs)',letterSpacing:'2px',fontWeight:'700',color:'var(--text-dim)',display:'block',marginBottom:'6px' };
const campo = { width:'100%',background:'var(--bg-input)',border:'1px solid var(--border2)',borderRadius:'8px',padding:'10px 14px',color:'var(--text)',fontSize:'var(--font-size-sm)',outline:'none',boxSizing:'border-box' };

// Avviso Dink (21/10 titolare): registrazione e documenti dell'app li segue l'assistenza Dink
const AvvisoDink = () => (
  <div style={{ display:'flex',gap:'10px',alignItems:'flex-start',background:'#EFF6FF',border:'1px solid #BFDBFE',color:'#1E3A8A',borderRadius:'10px',padding:'12px 14px',fontSize:'var(--font-size-sm)',lineHeight:1.45 }}>
    <Info size={18} style={{ flexShrink:0, marginTop:'1px' }}/>
    <div>Problemi con la <b>registrazione</b> o i <b>documenti nell'app Dink</b>? Scrivi direttamente all'assistenza Dink: <a href={`mailto:${EMAIL_DINK}`} style={{ color:'#1D4ED8',fontWeight:700 }}>{EMAIL_DINK}</a>, sono loro che possono intervenire sul tuo account. Per tutto il resto scrivici pure qui.</div>
  </div>
);

export default function TicketsCliente() {
  const [tickets, setTickets]     = useState([]);
  const [selected, setSelected]   = useState(null);
  const [thread, setThread]       = useState(null);
  const [reply, setReply]         = useState('');
  const [replyFiles, setReplyFiles] = useState([]);
  const [showNew, setShowNew]     = useState(false);
  const [newForm, setNewForm]     = useState({ argomento:'', oggetto:'', testo:'' });
  const [newFiles, setNewFiles]   = useState([]);
  const [saving, setSaving]       = useState(false);
  const [err, setErr]             = useState('');
  const bottomRef                 = useRef(null);

  const load = () => api.get('/tickets').then(r => setTickets(r.data)).catch(console.error);

  useEffect(() => { load(); }, []);

  const openTicket = async (id) => {
    setSelected(id); setErr(''); setReply(''); setReplyFiles([]);
    const r = await api.get(`/tickets/${id}`);
    setThread(r.data);
    avvisaTicketCambiati(); load();
    setTimeout(() => bottomRef.current?.scrollIntoView({ behavior:'smooth' }), 100);
  };

  const sendReply = async () => {
    if (!reply.trim() && !replyFiles.length) return;
    setSaving(true); setErr('');
    try {
      await api.post(`/tickets/${selected}/reply`, { testo: reply, allegati: replyFiles.map(f => ({ nome: f.nome, dati: f.dati })) });
      await openTicket(selected);
      load();
    } catch (e) { setErr(e.response?.data?.error || 'Invio non riuscito'); }
    finally { setSaving(false); }
  };

  const createTicket = async (e) => {
    e.preventDefault();
    if (!newForm.argomento) { setErr("Scegli l'argomento"); return; }
    setSaving(true); setErr('');
    try {
      const r = await api.post('/tickets', { ...newForm, allegati: newFiles.map(f => ({ nome: f.nome, dati: f.dati })) });
      setShowNew(false);
      setNewForm({ argomento:'', oggetto:'', testo:'' }); setNewFiles([]);
      load();
      openTicket(r.data.id);
    } catch (e) { setErr(e.response?.data?.error || 'Invio non riuscito'); }
    finally { setSaving(false); }
  };

  if (selected && thread) {
    const puoScrivere = thread.stato !== 'CHIUSO' || thread.chiusa_auto;
    return (
      <div style={{ maxWidth:'720px' }}>
        <button onClick={() => { setSelected(null); setThread(null); }}
          style={{ display:'flex',alignItems:'center',gap:'6px',background:'none',border:'none',color:'var(--text-dim)',cursor:'pointer',fontSize:'var(--font-size-xs)',fontWeight:'700',letterSpacing:'1px',marginBottom:'20px',padding:0 }}>
          <ChevronLeft size={14}/> TUTTE LE RICHIESTE
        </button>

        <div style={{ display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:'10px',marginBottom:'24px',flexWrap:'wrap' }}>
          <div>
            <h1 style={{ fontFamily:"'Barlow Condensed'",fontSize:'var(--font-size-xl)',fontWeight:'700',letterSpacing:'2px',margin:0 }}>{thread.oggetto}</h1>
            <div style={{ marginTop:'6px',display:'flex',gap:'6px',flexWrap:'wrap' }}>
              <span style={{ background:`${STATO_COLOR[thread.stato]}20`,color:STATO_COLOR[thread.stato],border:`1px solid ${STATO_COLOR[thread.stato]}40`,borderRadius:'4px',padding:'2px 10px',fontSize: 'var(--font-size-xs)',fontWeight:'700' }}>
                {STATO_LABEL[thread.stato]}
              </span>
              <span style={{ background:'var(--bg-input)',color:'var(--text-muted)',borderRadius:'4px',padding:'2px 10px',fontSize:'var(--font-size-xs)',fontWeight:'700' }}>{thread.argomento_label}</span>
            </div>
          </div>
          <div style={{ fontSize:'var(--font-size-xs)',color:'var(--text-dim)' }}>#{thread.id} · {fmtDate(thread.created_at)}</div>
        </div>

        {thread.argomento === 'DINK' && <div style={{ marginBottom:'16px' }}><AvvisoDink/></div>}

        <div style={{ display:'flex',flexDirection:'column',gap:'12px',marginBottom:'24px' }}>
          {thread.messaggi?.map(m => {
            const isMine = m.user_id === thread.user_id;
            return (
              <div key={m.id} style={{ display:'flex',flexDirection:'column',alignItems:isMine?'flex-end':'flex-start' }}>
                <div style={{ background:isMine?'#F4600C15':'var(--bg-card)',border:`1px solid ${isMine?'#F4600C30':'var(--border)'}`,borderRadius:'10px',padding:'12px 16px',maxWidth:'80%' }}>
                  <div style={{ fontSize:'var(--font-size-xs)',color:'var(--text-dim)',marginBottom:'6px',fontWeight:'700' }}>
                    {isMine ? 'Tu' : (m.user?.nome || 'Staff')} · {fmtDate(m.created_at)}
                  </div>
                  {m.testo && <div style={{ fontSize:'var(--font-size-sm)',whiteSpace:'pre-wrap',wordBreak:'break-word' }}>{m.testo}</div>}
                  <ElencoAllegati allegati={m.allegati}/>
                </div>
              </div>
            );
          })}
          <div ref={bottomRef}/>
        </div>

        {thread.stato === 'CHIUSO' && thread.chiusa_auto && (
          <div style={{ fontSize:'var(--font-size-xs)',color:'var(--text-dim)',marginBottom:'8px' }}>Chiusa da sola dopo 7 giorni senza tue risposte. Se scrivi di nuovo si riapre.</div>
        )}
        {err && <div style={{ color:'#B42318',fontSize:'var(--font-size-sm)',marginBottom:'8px' }}>{err}</div>}
        {puoScrivere ? (
          <div style={{ display:'flex',flexDirection:'column',gap:'8px' }}>
            <div style={{ display:'flex',gap:'10px',alignItems:'flex-end' }}>
              <textarea
                style={{ flex:1,background:'var(--bg-input)',border:'1px solid var(--border2)',borderRadius:'8px',padding:'10px 14px',color:'var(--text)',fontSize:'var(--font-size-sm)',resize:'vertical',minHeight:'70px',outline:'none' }}
                placeholder="Scrivi un messaggio..." maxLength={5000}
                value={reply} onChange={e => setReply(e.target.value)}
                onKeyDown={e => { if (e.key==='Enter' && (e.ctrlKey||e.metaKey)) sendReply(); }}
              />
              <button onClick={sendReply} disabled={saving || (!reply.trim() && !replyFiles.length)}
                style={{ background:'#F4600C',border:'none',borderRadius:'8px',padding:'10px 16px',color:'#fff',cursor:'pointer',display:'flex',alignItems:'center',gap:'6px',fontSize:'var(--font-size-xs)',fontWeight:'700',opacity:((!reply.trim() && !replyFiles.length)||saving)?0.5:1 }}>
                <Send size={13}/> {saving ? 'INVIO…' : 'INVIA'}
              </button>
            </div>
            <SceltaAllegati files={replyFiles} setFiles={setReplyFiles} onErrore={setErr}/>
          </div>
        ) : (
          <div style={{ textAlign:'center',color:'var(--text-dim)',fontSize:'var(--font-size-sm)',padding:'16px',background:'var(--bg-card)',borderRadius:'8px',border:'1px solid var(--border)' }}>
            Questa richiesta è stata chiusa: se ti serve altro aprine una nuova
          </div>
        )}
      </div>
    );
  }

  return (
    <div style={{ maxWidth:'720px' }}>
      <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',gap:'10px',marginBottom:'24px',flexWrap:'wrap' }}>
        <div>
          <h1 style={{ fontFamily:"'Barlow Condensed'",fontSize:'var(--font-size-xl)',fontWeight:'700',letterSpacing:'2px',margin:0 }}>SUPPORTO</h1>
          <p style={{ color:'var(--text-dim)',fontSize:'var(--font-size-sm)',marginTop:'4px' }}>Apri una richiesta, ti risponderemo il prima possibile</p>
        </div>
        <button onClick={() => { setShowNew(true); setErr(''); }}
          style={{ background:'#F4600C',border:'none',borderRadius:'8px',padding:'10px 16px',color:'#fff',cursor:'pointer',display:'flex',alignItems:'center',gap:'6px',fontSize:'var(--font-size-xs)',fontWeight:'700' }}>
          <Plus size={13}/> NUOVA RICHIESTA
        </button>
      </div>

      {showNew && (
        <form onSubmit={createTicket} style={{ background:'var(--bg-card)',border:'1px solid #F4600C30',borderRadius:'12px',padding:'20px',marginBottom:'20px' }}>
          <div style={{ fontSize: 'var(--font-size-xs)',letterSpacing:'2px',fontWeight:'700',color:'var(--text-dim)',marginBottom:'14px' }}>NUOVA RICHIESTA</div>
          <div style={{ display:'flex',flexDirection:'column',gap:'12px' }}>
            <div>
              <label style={etichetta}>DI COSA SI TRATTA? *</label>
              <div style={{ display:'flex',flexWrap:'wrap',gap:'6px' }}>
                {ARGOMENTI_TICKET.map(a => (
                  <button type="button" key={a.chiave} onClick={() => setNewForm(f => ({ ...f, argomento: a.chiave }))}
                    style={{ border:'1px solid var(--border2)',borderRadius:'999px',padding:'8px 14px',fontSize:'13px',fontWeight:600,cursor:'pointer',
                      ...(newForm.argomento === a.chiave ? { background:'#F4600C',borderColor:'#F4600C',color:'#fff' } : { background:'var(--bg-input)',color:'var(--text)' }) }}>
                    {a.label}
                  </button>
                ))}
              </div>
            </div>
            {newForm.argomento === 'DINK' && <AvvisoDink/>}
            <div>
              <label style={etichetta}>OGGETTO *</label>
              <input style={campo} maxLength={150}
                value={newForm.oggetto} onChange={e=>setNewForm(f=>({...f,oggetto:e.target.value}))} required placeholder="Es. Non vedo il mio ordine"/>
            </div>
            <div>
              <label style={etichetta}>MESSAGGIO *</label>
              <textarea style={{ ...campo,resize:'vertical',minHeight:'90px' }} maxLength={5000}
                value={newForm.testo} onChange={e=>setNewForm(f=>({...f,testo:e.target.value}))} required placeholder="Descrivi la tua richiesta..."/>
            </div>
            <SceltaAllegati files={newFiles} setFiles={setNewFiles} onErrore={setErr}/>
          </div>
          {err && <div style={{ color:'#B42318',fontSize:'var(--font-size-sm)',marginTop:'10px' }}>{err}</div>}
          <div style={{ display:'flex',gap:'8px',justifyContent:'flex-end',marginTop:'14px' }}>
            <button type="button" onClick={() => { setShowNew(false); setErr(''); }}
              style={{ background:'var(--bg-input)',border:'1px solid var(--border2)',borderRadius:'8px',padding:'8px 14px',color:'var(--text-dim)',cursor:'pointer',fontSize:'var(--font-size-xs)',fontWeight:'700' }}>
              ANNULLA
            </button>
            <button type="submit" disabled={saving}
              style={{ background:'#F4600C',border:'none',borderRadius:'8px',padding:'8px 16px',color:'#fff',cursor:'pointer',fontSize:'var(--font-size-xs)',fontWeight:'700' }}>
              {saving ? 'INVIO...' : 'INVIA RICHIESTA'}
            </button>
          </div>
        </form>
      )}

      {tickets.length === 0 ? (
        <div style={{ textAlign:'center',color:'var(--text-dim)',padding:'60px 0' }}>
          <MessageSquare size={40} color="var(--text-dim)" style={{ marginBottom:'12px' }}/>
          <div style={{ fontWeight:'700' }}>Nessuna richiesta aperta</div>
          <div style={{ fontSize:'var(--font-size-sm)',marginTop:'4px' }}>Tocca "Nuova richiesta" per contattare lo staff</div>
        </div>
      ) : (
        <div style={{ display:'flex',flexDirection:'column',gap:'8px' }}>
          {tickets.map(t => (
            <div key={t.id} onClick={() => openTicket(t.id)}
              style={{ background:'var(--bg-card)',border:'1px solid var(--border)',borderRadius:'10px',padding:'16px 20px',cursor:'pointer',display:'flex',alignItems:'center',gap:'14px' }}
              onMouseEnter={e=>e.currentTarget.style.borderColor='var(--border2)'}
              onMouseLeave={e=>e.currentTarget.style.borderColor='var(--border)'}>
              <MessageSquare size={18} color={STATO_COLOR[t.stato]}/>
              <div style={{ flex:1,minWidth:0 }}>
                <div style={{ fontWeight:'700',fontSize:'var(--font-size-sm)', display:'flex', alignItems:'center', gap:'8px', flexWrap:'wrap' }}>
                  {t.oggetto}
                  {t.da_leggere && <span style={{ fontSize:'11px', fontWeight:'800', color:'#fff', background:'#EF4444', borderRadius:'999px', padding:'2px 8px' }}>Nuova risposta</span>}
                </div>
                <div style={{ color:'var(--text-dim)',fontSize:'var(--font-size-xs)',marginTop:'2px' }}>
                  {t.argomento_label} · #{t.id} · {fmtDate(t.created_at)} · {t._count?.messaggi ?? t.messaggi?.length ?? 0} messaggi
                </div>
              </div>
              <span style={{ background:`${STATO_COLOR[t.stato]}20`,color:STATO_COLOR[t.stato],border:`1px solid ${STATO_COLOR[t.stato]}40`,borderRadius:'4px',padding:'2px 10px',fontSize: 'var(--font-size-xs)',fontWeight:'700',whiteSpace:'nowrap' }}>
                {STATO_LABEL[t.stato]}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
